import { ButtonHTMLAttributes, FC, SVGProps } from 'react';

import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { GPTGameNameType } from 'src/EXPERIMENTAL_LIB/gpt/games';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  Icon: FC<SVGProps<SVGSVGElement>>;
  title: string;
  additionalClassName?: string;
  badgeContent?: string;
  gameName: GPTGameNameType;
}

export const SampleGptButton = ({ Icon, title, badgeContent, ...props }: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button mode="button-tertiary" className="!p-1.5 flex gap-0.5 w-full" {...props}>
      <Icon className="min-h-5 min-w-5 h-7 w-7" />
      <div className="flex flex-1 items-center justify-start gap-1">
        <div className=" flex-col items-center justify-center gap-0.5">
          <p className="text-fg-theme-secondary text-left text-sm font-bold">{t(title)}</p>
        </div>
        {badgeContent && (
          <div className="bg-feedback-300 py-0.5 text-xs font-bold rounded-br-xl rounded-tl-xl ml-auto">
            {t(badgeContent)}
          </div>
        )}
      </div>
    </Button>
  );
};
